// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

// ABSOLUTE PATH IMPORTS
import Card from "components/emission/cards/Card";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CardsList.m.scss";

@themr("@lifepay/cards-list", styles)
export default class CardsList extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    data: PropTypes.object,
    cards: PropTypes.array,
    selectedCard: PropTypes.string,
    changeSelected: PropTypes.func,
    updateQuery: PropTypes.func,
  };

  render() {
    const {
      theme,
      cards,
      selectedCard,
      changeSelected,
      updateQuery,
    } = this.props;
    return (
      <div className={theme.wrapper}>
        <div className={classnames(theme.header)}>
          <div className={classnames(theme.item)}>{"Платежная система"}</div>
          <div className={classnames(theme.item)}>{"pan"}</div>
          <div className={classnames(theme.item)}>{"Срок действия"}</div>
          <div className={classnames(theme.item)}>{"Статус"}</div>
          <div className={classnames(theme.item)}>
            {"Попытки ввода пинкода"}
          </div>
          <div className={classnames(theme.item)}>{"SMS"}</div>
          <div className={classnames(theme.item)}>{"Баланс"}</div>
          <div className={classnames(theme.item)}>{"Валюта"}</div>
        </div>
        {cards
          ? cards.map((card, index) => {
              return (
                <Card
                  card={card}
                  key={card.cardId}
                  selected={selectedCard === card.cardId}
                  onChange={changeSelected}
                  updateQuery={updateQuery}
                />
              );
            })
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/CardsList/CardsList.js